import { useState } from 'react';

import { ChequeDetails } from '@/components/postgrid/cheque-details';
import { PostgridSubNavigation } from '@/components/postgrid/common/PostgridSubNavigation';
import { LetterDetails } from '@/components/postgrid/postgrid-letters/letter-details';
import { MailableTable } from '@/components/postgrid/postgrid-mailables/mailable-table/MailableTable';
import { Heading } from '@/components/ui/catalyst/heading';

/**
 * PostGrid Dashboard - Main page focused on mailable table with navigation to contacts
 */
export const PostgridDashboard: React.FC = () => {
  // Detail view state
  const [selectedMailableId, setSelectedMailableId] = useState<string | null>(
    null,
  );
  const [selectedMailableType, setSelectedMailableType] = useState<
    'cheque' | 'letter' | null
  >(null);

  const handleViewDetails = (id: string, type: 'cheque' | 'letter') => {
    setSelectedMailableId(id);
    setSelectedMailableType(type);
  };

  const handleCloseDetails = () => {
    setSelectedMailableId(null);
    setSelectedMailableType(null);
  };

  return (
    // Follow TaskListView pattern: flex container with explicit height
    <div
      className="flex flex-col overflow-hidden bg-zinc-50 dark:bg-zinc-950"
      style={{ height: '100vh', contain: 'layout style' }}
    >
      {/* Header - flex-shrink-0 */}
      <div className="flex-shrink-0 bg-white border-b border-zinc-200 dark:bg-zinc-900 dark:border-zinc-800">
        <div className="px-6 py-4">
          <Heading className="text-zinc-900 dark:text-white font-semibold">
            Mail
          </Heading>
        </div>
        <PostgridSubNavigation className="px-6" />
      </div>

      {/* Content - flex-1 with internal flex layout */}
      <div className="flex flex-1 min-h-0 flex-col overflow-hidden p-6">
        <MailableTable onDetailsClick={handleViewDetails} />
      </div>

      {/* Detail Drawers */}
      {selectedMailableId && selectedMailableType === 'cheque' && (
        <ChequeDetails
          chequeId={selectedMailableId}
          open
          onOpenChange={handleCloseDetails}
        />
      )}

      {selectedMailableId && selectedMailableType === 'letter' && (
        <LetterDetails
          letterId={selectedMailableId}
          open
          onOpenChange={handleCloseDetails}
        />
      )}
    </div>
  );
};
